<div mat-dialog-title>
    <div class="page-title-icon">
      <span class="card-header-value dialogue-tittle"> Register a Kit </span>
      <div class="subtitle">
        Please enter the 12 digit code which can be found on your sample collection kit.
      </div>
    </div>
  </div>
  <div class="form-container">
    <form [formGroup]="genomeDataOrderForm" (ngSubmit)="onSubmit(genomeDataOrderForm)" validate autocomplete="off">
      <div class="card-row">
        <div class="card-column">
          <mat-form-field appearance="outline">
            <mat-label>Enter Barcode</mat-label>
            <input placeholder="eg GFXC1234GF1234" matInput formControlName="barcode" id="barcode" required maxlength="14">
            <mat-error *ngIf="genomeDataOrderForm.controls.barcode.errors?.required">
              Please enter a Barcode.
            </mat-error>
            <mat-error *ngIf="(genomeDataOrderForm.controls.barcode.errors?.minlength || genomeDataOrderForm.controls.barcode.errors?.maxlength) 
                              && !genomeDataOrderForm.controls.barcode.errors?.required">
              The barcode must be between 12-14 characters long.
            </mat-error>
            <mat-error *ngIf="genomeDataOrderForm.controls.barcode.errors?.pattern
                              && !genomeDataOrderForm.controls.barcode.errors?.required 
                              && !genomeDataOrderForm.controls.barcode.errors?.minlength
                              && !genomeDataOrderForm.controls.barcode.errors?.maxlength">
              Please enter a valid Barcode.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="card-row">
        <div class="card-column">
          <mat-form-field appearance="outline">
            <mat-label>Manually Re-enter Barcode</mat-label>
            <input placeholder="eg GFXC1234GF1234" matInput formControlName="confirmBarcode" id="reEnterBarcode" required
              maxlength="14" (paste)="$event.preventDefault()" (copy)="$event.preventDefault()" (cut)="$event.preventDefault()">
            <mat-error *ngIf="genomeDataOrderForm.controls.confirmBarcode.errors?.required">
              Please re-enter a Barcode.
            </mat-error>
            <mat-error *ngIf="(genomeDataOrderForm.controls.confirmBarcode.errors?.minlength
                              || genomeDataOrderForm.controls.confirmBarcode.errors?.maxlength )
                              && !genomeDataOrderForm.controls.confirmBarcode.errors?.required">
              The barcode must be between 12-14 characters long.
            </mat-error>
            <mat-error *ngIf="genomeDataOrderForm.controls.barcode.errors?.pattern
                              && !genomeDataOrderForm.controls.barcode.errors?.required
                              && !genomeDataOrderForm.controls.barcode.errors?.minlength
                              && genomeDataOrderForm.controls.barcode.errors?.maxlength">
              Please enter a valid barcode.
            </mat-error>
            <mat-error *ngIf="genomeDataOrderForm.controls.confirmBarcode.errors?.mustMatch &&
                              !genomeDataOrderForm.controls.confirmBarcode.errors?.required &&
                              !genomeDataOrderForm.controls.confirmBarcode.errors?.pattern">
              Barcodes do not match
            </mat-error>
          </mat-form-field>
        </div>
      </div>
  
      <div class="card-row">
        <span class="align-left">
          <button type="button" id="cancel_user_button" (click)="dialogRef.close('cancel')" mat-stroked-button>Cancel</button>
        </span>
        <span class="align-right">
          <button type="submit" id="save_order_test_button" mat-flat-button color="primary"
            [disabled]="!genomeDataOrderForm.valid">Submit</button>
        </span>
  
      </div>
    </form>
  </div>